// import { FETCH_CMS_REQUEST, FETCH_CMS_SUCCESS, FETCH_CMS_FAILURE } from "../ActionTypes/ActionTypes";


const initialState = {}; //  Ensure state starts as an empty object

const cmsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_CMS_DATA":
            return {
                ...state,
                [action.payload.identifier]: action.payload
            };

        case "CMS_ERROR":
            return { ...state, error: action.payload };

        default:
            return state;
    }
};

export default cmsReducer;



